import type {
  FormInstance as AntdFormInstance,
  FormProps as AntdFormProps,
} from "antd";
import { Form as AntdForm } from "antd";
import { FormLabelAlign } from "antd/es/form/interface";
import React, { forwardRef, ReactNode } from "react";
import * as styles from "./Form.css";

type AntdFormType = typeof AntdForm;
// Deliberately use any for props/ref here; we cast to typeof AntdForm to preserve AntD’s overloaded typing.
const Form = forwardRef<any, any>(
  (
    { leftAlignedLabels, requiredMark, requiredMarkPosition, ...props },
    ref
  ) => {
    const setAfterRequiredMark = (
      label: ReactNode,
      { required }: { required: boolean }
    ) => {
      return (
        <>
          {label}
          {required ? <RequiredAsteriskAfter /> : null}
        </>
      );
    };
    const leftAlignedLabelsStyle =
      leftAlignedLabels && props.layout === "horizontal"
        ? {
            labelCol: { flex: "33%" },
            labelAlign: "left" as FormLabelAlign,
            wrapperCol: { flex: 1 },
            style: { maxWidth: 600 },
          }
        : null;

    return (
      <AntdForm
        {...props}
        ref={ref}
        requiredMark={
          !requiredMark && requiredMarkPosition === "after"
            ? setAfterRequiredMark
            : requiredMark
        }
        {...leftAlignedLabelsStyle}
      />
    );
  }
) as unknown as AntdFormType;

Form.Item = AntdForm.Item;
Form.List = AntdForm.List;
Form.ErrorList = AntdForm.ErrorList;
Form.Provider = AntdForm.Provider;
Form.useForm = AntdForm.useForm;
Form.useWatch = AntdForm.useWatch;
Form.displayName = "Form";

export const RequiredAsteriskAfter = () => {
  return <span className={`${styles.requiredAsterisk}`} />;
};
export type FormInstance = AntdFormInstance;
export type RequiredMarkPosition = "before" | "after";
export interface FormProps extends AntdFormProps {
  // NOTE: any props listed here needs to be added in antd-form-augmentation.d.ts
  leftAlignedLabels?: boolean;
  requiredMarkPosition?: RequiredMarkPosition;
}
export default Form;
